import { render, staticRenderFns } from "./BankAccountSwift.vue?vue&type=template&id=0b9f4c8b&scoped=true"
import script from "./BankAccountSwift.vue?vue&type=script&lang=js"
export * from "./BankAccountSwift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f4c8b",
  null
  
)

export default component.exports